import { createHighlighterCore, type HighlighterCore } from "shiki/core"
import { createJavaScriptRegexEngine } from "shiki/engine/javascript"
import liquid from "shiki/langs/liquid.mjs"
import json from "shiki/langs/json.mjs"
import ruby from "shiki/langs/ruby.mjs"
import html from "shiki/langs/html.mjs"
import css from "shiki/langs/css.mjs"
import githubLight from "shiki/themes/github-light.mjs"
import githubDark from "shiki/themes/github-dark.mjs"

export type CodeBlockLanguage = "liquid" | "json" | "ruby" | "html" | "css"

export const CODE_BLOCK_THEMES = { light: "github-light", dark: "github-dark" } as const

let highlighterPromise: Promise<HighlighterCore> | undefined

export function getCodeHighlighter(): Promise<HighlighterCore> {
  if (!highlighterPromise) {
    highlighterPromise = createHighlighterCore({
      themes: [githubLight, githubDark],
      langs: [liquid, json, ruby, html, css],
      engine: createJavaScriptRegexEngine()
    })
  }

  return highlighterPromise
}
